module.exports = new __parcel__URL__("t-rex.d85831fb.svg").toString();